import { FC, Suspense, lazy } from "react";

import LoadingScreen from "../../components/Desktop/LoadingScreen";

const PawditPage = lazy(() => import("./PawditPage"));

/**
 * Route wrapper that loads the Pawdit page as its own chunk.
 *
 * Pawdit is a standalone campaign page, so keeping it out of the shared bundle means the
 * existing HomeCook pages do not pay for markup, styles, or copy they never render.
 */
export const PawditRoute: FC = () => (
  <Suspense fallback={<LoadingScreen />}>
    <PawditPage />
  </Suspense>
);

export default PawditRoute;
